module.exports = "https://beta.voredev.ru/assets/index/telegram-mini-01f22906fda16ff43a2099af310403d1.svg";